import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { InvoicingProductInput } from "../InvoicingProductInput";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import Loader from "../../Shared/Loader";
import { api } from "../../../services/axios";
import { toast } from "react-toastify";
import { useCompany } from "../../../hooks/useCompany";
import { InvoincingConsolidationByProducts } from "../../../pages/Credit/AdditionalBillingDataFinanceCredits";
import { formatCurrency } from "../../../utils/formatCurrency";
import { Button, MenuItem, Select, TextField } from "@mui/material";

const schema = yup.object().shape({
    exports: yup.number(),
    quantityProduced: yup.number(),
    ipiInvoicing: yup.number(),
    zfmSales: yup.number(),
    icms: yup.number(),
});

interface AdditionalBillingDataFinanceCreditsFormProps {
    export: number;
    produtionQuantity: number;
    valueSalesWithIPISuspension: number;
    valueSalesZFM: number;
    earnedICMS: number;
    ppbOrdinance: string;
    ppbScorePA: number;
    targetScoreMPD: number;
    complementaryPD: number;
    pdimValue: number;
    creditValue: number | null;
}

interface DataFinanceCreditsFormProps {
    creditIsValidated: boolean;
    invoicingConsolidationValues: InvoincingConsolidationByProducts | undefined;
    countings: string | undefined;
    produtionQuantity: number;
    valueSalesWithIPISuspension: number;
    valueSalesZFM: number;
    earnedICMS: number;
    ppbOrdinance: string;
    ppbScorePA: number;
    targetScoreMPD: number;
    complementaryPD: number;
    export: number;
    id: string | null;
    productId: string | null;
    serviceId: string | null;
    pdimValue: number;
    creditValue: number | null;
    calculationBasis: number | null;
    tax: number;
    taxLimit: number;
}

export function AdditionalBillingDataFinanceCreditsForm(
    props: DataFinanceCreditsFormProps
) {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [financeId, setFinanceId] = useState(props.id);
    const { creditId, productId, isTecnac } = useParams();
    const { company, updateHeaderValues } = useCompany();
    const [paMpd, setPaMpd] = useState(0);
    const [selectedValue, setSelectValue] = useState("");
    const [ValuePpbOrdinance, setValuePpbOrdinance] = useState<string>("0");

    const {
        register,
        handleSubmit,
        setValue,
        getValues,
        watch,
        control,
        formState: { errors },
    } = useForm<AdditionalBillingDataFinanceCreditsFormProps>({
        resolver: yupResolver(schema),
        defaultValues: {
            export: props.export,
            valueSalesZFM: props.valueSalesZFM,
            earnedICMS: props.earnedICMS,
            produtionQuantity: props.produtionQuantity,
            valueSalesWithIPISuspension: props.valueSalesWithIPISuspension,
            ppbOrdinance: props.ppbOrdinance,
            ppbScorePA: props.ppbScorePA,
            targetScoreMPD: props.targetScoreMPD,
            complementaryPD: props.complementaryPD,
            pdimValue: props.pdimValue,
            creditValue: props.creditValue
        },
    });

    async function submitForm(
        data: AdditionalBillingDataFinanceCreditsFormProps
    ) {
        try {
            setLoading(true);
            if (company.counting != 0) {
                if (financeId == null) {
                    const object = {
                        produtionQuantity: data.produtionQuantity,
                        valueSalesWithIPISuspension: data.valueSalesWithIPISuspension,
                        valueSalesZFM: data.valueSalesZFM,
                        earnedICMS: data.earnedICMS,
                        export: data.export,
                        productId: productId,
                        creditId: creditId,
                        serviceId: company.serviceId,
                        isTecnac: isTecnac == "1" ? true : false,
                        pdimValue: data.pdimValue ?? 0,
                        creditValue: data.creditValue ?? 0
                    };

                    const result = await api.post(
                        `/AdditionalBillingDataFinanceCredits/Post`,
                        object
                    );

                    const response = await result.data;

                    if (response.statusCode === 200) {
                        toast.success("Faturamento criado com sucesso!");
                        setFinanceId(response.data.id);
                    }
                } else {

                    const object = {
                        id: financeId,
                        produtionQuantity: data.produtionQuantity,
                        valueSalesWithIPISuspension: data.valueSalesWithIPISuspension,
                        valueSalesZFM: data.valueSalesZFM,
                        earnedICMS: data.earnedICMS,
                        export: data.export,
                        productId: productId,
                        creditId: creditId,
                        serviceId: company.serviceId,
                        pdimValue: data.pdimValue ?? 0,
                        creditValue: data.creditValue ?? 0
                    };

                    const result = await api.put(
                        `/AdditionalBillingDataFinanceCredits/Put`,
                        object
                    );

                    const response = await result.data;

                    if (response.statusCode === 200) {
                        toast.success("Faturamento editado com sucesso!");
                    }
                }
            } else {
                if (data.targetScoreMPD != 1 && data.ppbScorePA != 1) {
                    data.ppbOrdinance = "1";
                }

                if (financeId == null) {
                    const object = {
                        produtionQuantity: data.produtionQuantity,
                        valueSalesWithIPISuspension: data.valueSalesWithIPISuspension,
                        valueSalesZFM: data.valueSalesZFM,
                        earnedICMS: data.earnedICMS,
                        ppbOrdinance: data.ppbOrdinance == "1" ? true : false,
                        ppbScorePA: parseFloat(data.ppbScorePA.toString()),
                        targetScoreMPD: parseFloat(data.targetScoreMPD.toString()),
                        complementaryPD: parseFloat(data.complementaryPD.toString()),
                        export: data.export,
                        productId: productId,
                        creditId: creditId,
                        serviceId: company.serviceId,
                        isTecnac: isTecnac == "1" ? true : false,
                        pdimValue: data.pdimValue ?? 0,
                        creditValue: data.creditValue ?? 0

                    };

                    const result = await api.post(
                        `/AdditionalBillingDataFinanceCredits/Post`,
                        object
                    );

                    const response = await result.data;

                    if (response.statusCode === 200) {
                        toast.success("Faturamento criado com sucesso!");
                        setFinanceId(response.data.id);
                    }
                } else {
                    const object = {
                        id: financeId,
                        produtionQuantity: data.produtionQuantity,
                        valueSalesWithIPISuspension: data.valueSalesWithIPISuspension,
                        valueSalesZFM: data.valueSalesZFM,
                        earnedICMS: data.earnedICMS,
                        ppbOrdinance: data.ppbOrdinance == "1" ? true : false,
                        ppbScorePA: isNaN(parseFloat(data.ppbScorePA.toString())) ? 0 : data.ppbScorePA,
                        targetScoreMPD: isNaN(parseFloat(data.targetScoreMPD.toString())) ? 0 : data.targetScoreMPD,
                        complementaryPD: isNaN(parseFloat(data.complementaryPD.toString())) ? 0 : data.complementaryPD,
                        export: data.export,
                        productId: productId,
                        creditId: creditId,
                        serviceId: company.serviceId,
                        pdimValue: isNaN(parseFloat(data.pdimValue.toString())) ? 0 : data.pdimValue,
                        creditValue: data.creditValue ?? 0
                    };

                    const result = await api.put(
                        `/AdditionalBillingDataFinanceCredits/AnnualUpdate`,
                        object
                    );

                    const response = await result.data;

                    if (response.statusCode === 200) {
                        toast.success("Faturamento editado com sucesso!");
                    }
                }
            }
            await updateHeaderValues();
        } catch (error: any) {
            toast.error(error);
        } finally {
            navigate(`/${company.serviceId}/credit/tabs/${creditId}/${props.countings}`)
            setLoading(false);
        }
    }
    const handleChange = (event: { target: { value: string; }; }) => {
        setValue("ppbOrdinance", event.target.value);

        const value = event.target.value;
        updateValuesPPBPA(value);
    };

    function calPaMpd() {
        const pa = getValues("ppbScorePA");
        const mpd = getValues("targetScoreMPD");

        let division = 0
        if (pa != 0 && mpd != 0) {
            division = pa / mpd;
        }

        setPaMpd(division);
    }

    function updateValuesPPBPA(value: string) {
        setSelectValue(value);

        if (value == "0") {
            setValue("ppbScorePA", 1);
            setValue("targetScoreMPD", 1);
            setPaMpd(1);
        } else {
            setValue("ppbScorePA", 0);
            setValue("targetScoreMPD", 0);
            setPaMpd(0);
        }
    }

    {/* 

    SE -> (PD&IM * Multiplicador * Relação PA/MPD ) + PD&IM + (Investimento complementar P&D Complementar/2,5) > (MAIOR QUE) Base de cálculo DO PRODUTO * limitador ---- > 
    Crédito Financeiro = Base de cálculo DO PRODUTO * Limitador

    SENAO -> Calculo da validação |^|

    */}
    function calCreditValue() {
        const pdimValue = Number(getValues("pdimValue"));
        const complementaryPD = Number(getValues("complementaryPD"));

        let calc = (pdimValue * props.tax * paMpd) + pdimValue + (complementaryPD / 2.5)
        if (calc > (props.calculationBasis != null ? props.calculationBasis * props.taxLimit : 0)) {
            setValue("creditValue", props.calculationBasis != null ? props.calculationBasis * props.taxLimit : 0);
            console.log(props.calculationBasis != null ? props.calculationBasis * props.taxLimit : 0);
        } else {
            setValue("creditValue", calc);
            console.log(calc);
        }

    }
    useEffect(() => {
        calCreditValue();
    }, [paMpd]);

    function getValuePpbOrdinance() {

        var ordinance = props.ppbOrdinance;
        if (ordinance) {
            setValuePpbOrdinance("1");
        } else {
            setValuePpbOrdinance("0");
        }

    }
    useEffect(() => {
        getValuePpbOrdinance();
        calPaMpd();
    }, []);

    useEffect(() => {
        updateValuesPPBPA(ValuePpbOrdinance);
    }, [ValuePpbOrdinance]);

    return (
        <>
            {loading && <Loader />}
            <form className="" onSubmit={handleSubmit(submitForm)}>
                <h4 className="mb-4">
                    <strong>Faturamento do produto</strong>
                </h4>
                <div>
                    <strong className="d-block mb-4">
                        Faturamento, Exportações, Quantidade Produzida e Tributos
                    </strong>
                    <div className="row">
                        <div className="col-md-6 col-sm-12">
                            <InvoicingProductInput
                                label="Faturamento Bruto no Mercado Interno (R$)"
                                value={formatCurrency(
                                    props.invoicingConsolidationValues?.totalInvoicing.toFixed(2)
                                )}
                                isDisabled={true}
                                control={control}
                            />
                        </div>

                        <div className="col-md-6 col-sm-12">
                            <InvoicingProductInput
                                label="Exportações (R$)"
                                name="export"
                                control={control}
                                value={
                                    props.creditIsValidated
                                        ? formatCurrency(props.export.toFixed(2))
                                        : props.export.toString()
                                }
                                isDisabled={props.creditIsValidated}
                            />
                        </div>
                    </div>
                    <div className="row invoincing-cards">
                        <div className="col-md-6 col-sm-12">
                            <InvoicingProductInput
                                label="Vendas Para ZFM (Zona Franca de Manaus x Equiparadas a Exportações) (R$)"
                                value={
                                    props.creditIsValidated
                                        ? formatCurrency(props.valueSalesZFM.toFixed(2))
                                        : props.valueSalesZFM.toString()
                                }
                                name="valueSalesZFM"
                                control={control}
                                isDisabled={props.creditIsValidated}
                            />
                        </div>
                        <div className="col-md-6 col-sm-12">
                            <InvoicingProductInput
                                label="Quantidade Produzida"
                                name="produtionQuantity"
                                value={
                                    props.creditIsValidated
                                        ? formatCurrency(props.produtionQuantity.toFixed(2))
                                        : props.produtionQuantity.toString()
                                }
                                control={control}
                                isDisabled={props.creditIsValidated}
                            />
                        </div>
                    </div>
                    <div className="row invoincing-cards">
                        <div className="col-md-6 col-sm-12">
                            <InvoicingProductInput
                                label="Faturamento com Suspensão de IPI - Lei 10.637/2002 (R$)"
                                name="valueSalesWithIPISuspension"
                                value={
                                    props.creditIsValidated
                                        ? formatCurrency(
                                            props.valueSalesWithIPISuspension.toFixed(2)
                                        )
                                        : props.valueSalesWithIPISuspension.toString()
                                }
                                control={control}
                                isDisabled={props.creditIsValidated}
                            />
                        </div>
                        <div className="w-100 input-container-no-bg"></div>
                    </div>
                </div>
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-4 border-bottom"></div>
                <div>
                    <strong className="d-block mb-4">
                        Recolhimento Sobre o Faturamento Bruto
                    </strong>
                    <div className="invoincing-cards mb-4 d-flex aling-items-center justify-content-between w-100">
                        <div>
                            <InvoicingProductInput
                                label="IPI (R$)"
                                value={formatCurrency(
                                    props.invoicingConsolidationValues?.totalIPI.toFixed(2)
                                )}
                                isDisabled={false}
                                control={control}
                            />
                        </div>
                        <div className="me-2 ms-2">
                            <InvoicingProductInput
                                label="Devoluções"
                                value={formatCurrency(
                                    props.invoicingConsolidationValues?.totalDevolutions.toFixed(
                                        2
                                    )
                                )}
                                isDisabled={true}
                                control={control}
                            />
                        </div>
                        <div>
                            <InvoicingProductInput
                                label="ICMS (ST) (R$)"
                                value={formatCurrency(
                                    props.invoicingConsolidationValues?.totalICMS.toFixed(2)
                                )}
                                isDisabled={true}
                                control={control}
                            />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <strong className="d-block mb-4">Incentivo Auferido</strong>
                    <div className="mb-4 d-flex align-items-center justify-content-between">
                        <div className="width-alone">
                            <InvoicingProductInput
                                label="ICMS (R$)"
                                name="earnedICMS"
                                value={
                                    props.creditIsValidated
                                        ? formatCurrency(props.earnedICMS.toFixed(2))
                                        : props.earnedICMS.toString()
                                }
                                control={control}
                                isDisabled={props.creditIsValidated}
                            />
                        </div>

                        <div className="width-without"></div>
                        <div className="width-without"></div>
                    </div>
                </div>
                {company.counting == 0 ? (
                    <>
                        <div className="row">
                            <strong className="d-block mb-4">Pontuação Portaria</strong>
                        </div>
                        <div className="row mb-4">
                            <div className="col-md-6 col-sm-12 " style={{ width: "35%" }}>
                                Produto cumpre portaria de PPB com pontuação
                            </div>
                            <div className="col-md-6 col-sm-12 " style={{ width: "65%" }}>
                                <Select
                                    className="w-100"
                                    id="outlined-select-currency"
                                    onChange={handleChange}
                                    defaultValue={ValuePpbOrdinance}
                                >
                                    <MenuItem value="1">Sim</MenuItem>
                                    <MenuItem value="0">Não</MenuItem>
                                </Select>
                            </div>
                        </div>
                        <div className="invoincing-cards mb-4 d-flex aling-items-center justify-content-between w-100">
                            <div>
                                <InvoicingProductInput
                                    label="Pontuação PPB Atingida pela Empresa (PA)"
                                    name="ppbScorePA"
                                    value={formatCurrency(
                                        props.ppbScorePA?.toFixed(2)
                                    )}
                                    isDisabled={selectedValue != "0" ? false : true}
                                    control={control}
                                    onBlur={calPaMpd}
                                />
                            </div>
                            <div className="me-2 ms-2">
                                <InvoicingProductInput
                                    label="Meta de Pontuação Portaria PPB (MPD)"
                                    name="targetScoreMPD"
                                    value={formatCurrency(
                                        props.targetScoreMPD?.toFixed(2)
                                    )}
                                    isDisabled={selectedValue != "0" ? false : true}
                                    control={control}
                                    onBlur={calPaMpd}
                                />
                            </div>

                            <div className="me-2 ms-2">
                                <InvoicingProductInput
                                    label="Relação PA/MPD"
                                    value={paMpd.toString()}
                                    isDisabled={true}
                                    control={control}
                                />
                            </div>
                            <div>
                                <InvoicingProductInput
                                    label="Investimento P&D Complementar"
                                    name="complementaryPD"
                                    value={formatCurrency(
                                        props.complementaryPD?.toFixed(2)
                                    )}
                                    isDisabled={selectedValue != "0" ? false : true}
                                    control={control}
                                />
                            </div>
                        </div>

                        {/* a partir daqui */}
                        <div className="row">
                            <strong className="d-block mb-4">Investimento e Crédito</strong>
                        </div>

                        <div className="invoincing-cards mb-4 d-flex aling-items-center justify-content-between w-100">
                            <div>
                                <InvoicingProductInput
                                    label="PD&IM - valor do investimento em Pesquisa, Desenvolvimento e inovação Mínima (R$)"
                                    name="pdimValue"
                                    value={formatCurrency(
                                        props.pdimValue?.toFixed(2)
                                    )}
                                    isDisabled={false}
                                    control={control}
                                    onBlur={calCreditValue}
                                />
                            </div>

                            <div>
                                <InvoicingProductInput
                                    label="Valor de Crédito (R$)"
                                    name="creditValue"
                                    value={formatCurrency(
                                        props.creditValue?.toFixed(2)
                                    )}
                                    isDisabled={true}
                                    control={control}
                                    onBlur={calCreditValue}

                                />
                            </div>


                        </div>
                    </>
                ) : (
                    <div></div>
                )}
                <div className="text-center">
                    {!props.creditIsValidated && (
                        <Button
                            variant="contained"
                            className="btn btn-success"
                            type="submit"
                        >
                            Salvar
                        </Button>
                    )}
                </div>
            </form >
        </>
    );
}
